'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import GladlyHelpCenterLegacy from './glady-help-center-legacy'

// dynamic import keeps Panda styles out of the legacy bundle; ssr stays on for identical server HTML
const HelpCenterDS = dynamic(
  () =>
    import(
      /* webpackChunkName: "contact-us-help-center-ds" */ '@src/components/blocks/contact-us-help-center-ds/contact-us-help-center-ds'
    ),
)

const GladlyHelpCenter = () => {
  if (shouldUseDesignSystem()) {
    return <HelpCenterDS />
  }
  return <GladlyHelpCenterLegacy />
}

export default GladlyHelpCenter
